import { render, staticRenderFns } from "./MonthlyRealisationPriceChart.vue?vue&type=template&id=243d949e&scoped=true"
import script from "./MonthlyRealisationPriceChart.vue?vue&type=script&lang=ts"
export * from "./MonthlyRealisationPriceChart.vue?vue&type=script&lang=ts"
import style0 from "./MonthlyRealisationPriceChart.vue?vue&type=style&index=0&id=243d949e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d949e",
  null
  
)

export default component.exports